var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 141,
    viewBox: "0 0 345 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1688 96.5078C45.7299 96.5078 57.5339 84.7197 57.5339 70.1783C57.5339 55.6369 45.7299 43.8488 31.1688 43.8488C16.6078 43.8488 4.80371 55.6369 4.80371 70.1783C4.80371 84.7197 16.6078 96.5078 31.1688 96.5078Z",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9424 1V140.344",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V140.344",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7314 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5205 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3086 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0977 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8867 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6748 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.252 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4629 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.041 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4072 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6182 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8291 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1943 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9834 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7725 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1387 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5605 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9268 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7148 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.293 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5039 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0811 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8691 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6592 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0244 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4473 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2354 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8135 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6016 28.8484V112.394",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M330.057 1V140.344",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M344 1V140.242",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M344 28.8484H1",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M344 1H1",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 106.824H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 104.039H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M330.056 101.254H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 109.609H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 95.6851H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 92.9001H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 90.1152H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 98.4695H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 84.5455H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 81.7606H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 78.9758H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 87.3304H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 73.406H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 70.6216H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 67.8363H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 76.1909H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 62.2665H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 59.4821H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 56.6968H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 65.0514H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 51.127H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 48.3425H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 45.5576H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 53.9122H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M330.056 39.9879H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 37.203H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 34.4181H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 31.6333H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 42.7727H14.9424",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M344 112.394H1",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.94844C8.53165 9.12249 9.32547 20.3586 1 20.8808V28.8485C19.0643 28.2877 20.1099 2.04432 1 1V8.94844Z",
    fill: "#3098F3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1 120.342C8.53165 120.516 9.32547 131.753 1 132.275V140.242C19.0643 139.682 20.1099 113.438 1 112.394V120.342Z",
    fill: "#3098F3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M344 132.294C336.468 132.12 335.674 120.884 344 120.362V112.394C325.935 112.955 324.89 139.198 344 140.242V132.294Z",
    fill: "#3098F3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M344 20.9001C336.468 20.726 335.674 9.48994 344 8.96778V1C325.935 1.56084 324.89 27.8042 344 28.8485V20.9001Z",
    fill: "#3098F3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 63.1763H99.627V97.4938H107.679V63.1763Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M114.845 63.1758H122.897V67.9688C123.976 66.09 125.479 64.7096 127.405 63.751C129.331 62.7924 131.566 62.3323 134.147 62.3323C136.651 62.3323 138.77 62.7541 140.466 63.5976C142.161 64.4412 143.509 65.5531 144.511 66.9718C145.358 68.2372 145.936 69.6559 146.245 71.228C146.553 72.8001 146.707 74.7556 146.707 77.1329V97.5317H138.655V79.7786C138.655 78.3216 138.539 76.9412 138.27 75.6375C138.038 74.3722 137.615 73.2602 137.037 72.3783C136.459 71.4581 135.688 70.7295 134.725 70.1927C133.762 69.6559 132.568 69.3875 131.142 69.3875C128.33 69.3875 126.249 70.3844 124.901 72.3783C123.552 74.3722 122.859 76.8262 122.859 79.7786V97.5317H114.807V63.1758H114.845Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M180.264 92.8539C179.185 94.5794 177.644 95.9214 175.641 96.9184C173.637 97.9153 171.634 98.3754 169.592 98.3754C166.972 98.3754 164.584 97.9153 162.426 96.9567C160.269 95.9981 158.381 94.6944 156.84 93.0073C155.299 91.3202 154.066 89.4414 153.218 87.2558C152.371 85.1086 151.908 82.8079 151.908 80.3156C151.908 77.9 152.332 75.5994 153.218 73.4138C154.066 71.2282 155.299 69.311 156.84 67.6239C158.381 65.9368 160.269 64.6331 162.426 63.6745C164.584 62.7159 166.972 62.2558 169.592 62.2558C171.595 62.2558 173.637 62.7542 175.641 63.7128C177.644 64.7098 179.185 66.0518 180.264 67.7773V47.1868H188.316V97.4552H180.264V92.8539ZM170.054 91.2435C171.595 91.2435 172.982 90.9368 174.254 90.3616C175.525 89.7865 176.565 88.9812 177.49 88.0227C178.376 87.0257 179.07 85.8754 179.571 84.5717C180.071 83.2297 180.303 81.8493 180.303 80.3923C180.303 78.9352 180.071 77.5165 179.571 76.2128C179.07 74.8708 178.376 73.7205 177.49 72.7619C176.604 71.765 175.525 70.9981 174.254 70.423C172.982 69.8478 171.595 69.5411 170.054 69.5411C168.513 69.5411 167.126 69.8478 165.893 70.423C164.661 70.9981 163.582 71.8033 162.696 72.7619C161.81 73.7589 161.116 74.9092 160.654 76.2128C160.192 77.5549 159.96 78.9352 159.96 80.3923C159.96 81.8493 160.192 83.2681 160.654 84.5717C161.116 85.9138 161.81 87.0641 162.696 88.0227C163.582 89.0196 164.661 89.7865 165.893 90.3616C167.165 90.9368 168.513 91.2435 170.054 91.2435Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M203.573 63.1763H195.521V97.4938H203.573V63.1763Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M234.548 75.7142C234.317 73.8354 233.585 72.34 232.352 71.1897C231.158 70.0393 229.155 69.4642 226.381 69.4642C224.801 69.4642 223.452 69.771 222.297 70.3461C221.179 70.9213 220.216 71.7265 219.407 72.7234C218.637 73.7203 218.02 74.8706 217.673 76.1743C217.288 77.478 217.134 78.8584 217.134 80.3538C217.134 81.8108 217.327 83.2295 217.673 84.5332C218.059 85.8752 218.637 87.0255 219.407 87.9841C220.178 88.9811 221.218 89.7479 222.451 90.3231C223.684 90.8982 225.148 91.205 226.881 91.205C229.232 91.205 231.004 90.7065 232.083 89.7479C233.2 88.751 234.009 87.409 234.548 85.6835H242.6C242.292 87.4473 241.753 89.0961 240.982 90.6682C240.212 92.2019 239.133 93.5823 237.746 94.7326C236.398 95.8829 234.779 96.7648 232.853 97.4166C230.965 98.0685 228.731 98.3752 226.226 98.3752C223.414 98.3752 220.948 97.8767 218.791 96.8798C216.633 95.8829 214.861 94.5409 213.397 92.8537C211.933 91.1666 210.854 89.2878 210.122 87.1022C209.39 84.955 209.005 82.6927 209.005 80.3154C209.005 78.0148 209.39 75.7525 210.122 73.567C210.854 71.3814 211.971 69.4642 213.397 67.7771C214.861 66.09 216.633 64.7863 218.752 63.751C220.871 62.7541 223.337 62.2556 226.149 62.2556C228.962 62.2556 231.351 62.6391 233.354 63.4443C235.357 64.2111 237.014 65.2464 238.324 66.5118C239.634 67.7771 240.636 69.1958 241.29 70.7679C241.945 72.3783 242.369 73.9887 242.523 75.6758H234.548V75.7142Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M257.781 63.1763H249.729V97.4938H257.781V63.1763Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M320.656 78.1301C321.85 78.5902 323.006 79.0503 324.124 79.5104C325.241 80.0089 326.281 80.6224 327.167 81.3509C328.053 82.0794 328.747 82.9613 329.286 83.9966C329.787 85.0319 330.057 86.3356 330.057 87.9076C330.057 89.6714 329.71 91.2052 328.978 92.5472C328.246 93.8892 327.283 94.9628 326.011 95.8064C324.74 96.65 323.276 97.3018 321.619 97.7236C319.924 98.1454 318.152 98.3371 316.303 98.3371C314.415 98.3371 312.643 98.0687 310.986 97.5319C309.291 96.995 307.827 96.1898 306.517 95.1546C305.207 94.0809 304.167 92.8156 303.396 91.2435C302.626 89.7098 302.24 87.9076 302.24 85.9138H310.1C310.1 88.176 310.716 89.7481 311.988 90.6684C313.259 91.5886 314.839 92.0487 316.765 92.0487C318.345 92.0487 319.693 91.742 320.772 91.1668C321.85 90.5917 322.39 89.5564 322.39 88.061C322.39 87.2941 322.159 86.6423 321.735 86.1438C321.273 85.6454 320.618 85.1853 319.731 84.7635C318.845 84.3417 317.728 83.9199 316.418 83.4598C315.108 82.9997 313.49 82.4629 311.679 81.7727C310.485 81.3126 309.406 80.8524 308.405 80.354C307.403 79.8555 306.517 79.242 305.785 78.5518C305.053 77.8616 304.475 77.0181 304.09 75.9828C303.704 74.9475 303.512 73.6822 303.512 72.2251C303.512 70.6147 303.858 69.196 304.552 67.969C305.245 66.742 306.17 65.7068 307.364 64.8249C308.559 63.9813 309.907 63.3295 311.487 62.9077C313.028 62.4859 314.723 62.2942 316.495 62.2942C318.306 62.2942 320.04 62.6009 321.619 63.1761C323.237 63.7512 324.624 64.5564 325.819 65.5917C327.013 66.627 327.938 67.854 328.631 69.2727C329.325 70.6914 329.671 72.2252 329.671 73.9123H321.812C321.812 72.3018 321.388 70.9981 320.502 70.0396C319.654 69.081 318.229 68.6209 316.264 68.6209C314.877 68.6209 313.721 68.9276 312.758 69.5795C311.795 70.2313 311.333 71.1515 311.333 72.3785C311.333 73.1071 311.525 73.7206 311.911 74.1807C312.296 74.6408 312.912 75.0626 313.683 75.446C314.453 75.8294 315.455 76.2129 316.649 76.6346C317.69 77.0564 319.077 77.5549 320.656 78.1301Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M103.634 58.728C106.825 58.728 109.413 56.153 109.413 52.9765C109.413 49.8 106.825 47.225 103.634 47.225C100.442 47.225 97.8545 49.8 97.8545 52.9765C97.8545 56.153 100.442 58.728 103.634 58.728Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M199.566 58.728C202.758 58.728 205.345 56.153 205.345 52.9765C205.345 49.8 202.758 47.225 199.566 47.225C196.374 47.225 193.787 49.8 193.787 52.9765C193.787 56.153 196.374 58.728 199.566 58.728Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M253.774 58.728C256.966 58.728 259.553 56.153 259.553 52.9765C259.553 49.8 256.966 47.225 253.774 47.225C250.582 47.225 247.995 49.8 247.995 52.9765C247.995 56.153 250.582 58.728 253.774 58.728Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M288.716 81.3893C288.716 88.0611 285.403 90.5534 280.78 90.5534C276.157 90.5534 272.843 88.0994 272.843 81.3893V63.2145H264.868V81.8494V82.2329C264.868 93.0458 271.687 98.4138 280.78 98.4138C289.872 98.4138 296.691 93.0458 296.691 82.2329V81.8494V63.2145H288.716V81.3893Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2471 66.0135C50.0426 66.0135 44.1865 60.1853 44.1865 53.0151C44.1865 45.8448 50.0426 40.0166 57.2471 40.0166C64.4517 40.0166 70.3078 45.8448 70.3078 53.0151C70.3463 60.147 64.4517 66.0135 57.2471 66.0135ZM57.2471 47.4169C54.165 47.4169 51.6607 49.9092 51.6607 52.9767C51.6607 56.0442 54.165 58.5366 57.2471 58.5366C60.3293 58.5366 62.8336 56.0442 62.8336 52.9767C62.8721 49.9092 60.3293 47.4169 57.2471 47.4169Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0367 101.328L58.7885 82.5013C57.7483 84.8786 56.3998 87.1026 54.7432 89.1348C50.7364 93.9661 45.15 97.417 38.9471 98.8357L37.252 91.5888C41.7596 90.5535 45.8435 88.0228 48.7715 84.4952C51.7766 80.8526 53.3947 76.4047 53.3947 71.6885L60.5608 69.9247L75.7789 97.8004L69.0367 101.328Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M344 140.243H1",
    stroke: "#3098F3",
    strokeWidth: 0.511834,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConstruction);
export default __webpack_public_path__ + "static/media/logo-construction.b54dd13a85518d2cb50b498202920bc9.svg";
export { ForwardRef as ReactComponent };